import React, { useEffect, useState, useContext } from "react";
import { MapTools } from "../../constants/WebMap";
import { displayArea, displayDistance } from "../../helpers/webMap";
import { LoadMapContext } from "../../pages/sections/web-map/LoadWebMap";

const MeasureToolTotalStats = ({ tool, markers = [] }) => {
  const { mapView } = useContext(LoadMapContext);
  const [totalDistance, setTotalDistance] = useState(0);

  useEffect(() => {
    let totalDistance = 0;
    if (tool === MapTools.AREA) {
      if (markers.length > 2 &&
        (JSON.stringify(markers[0]) ===
          JSON.stringify(markers[markers.length - 1])))
        totalDistance =
          window.google.maps.geometry?.spherical.computeArea(markers);
      setTotalDistance(totalDistance);
    } else {
      markers.forEach((marker, idx) => {
        if (idx !== markers.length - 1) {
          const origin = new window.google.maps.LatLng(marker.lat, marker.lng);
          const destination = new window.google.maps.LatLng(
            markers[idx + 1].lat,
            markers[idx + 1].lng
          );
          const distance =
            window.google.maps.geometry.spherical.computeDistanceBetween(
              origin,
              destination
            );
          totalDistance = totalDistance + distance;
        }
      });
      setTotalDistance(totalDistance);
    }
  }, [tool, markers]);

  return (
    <>
      {(tool === MapTools.AREA || tool=== MapTools.DISTANCE) && mapView === null && totalDistance && Number(totalDistance).toFixed(3) > 0 && (
        <div
          style={{
            position: "fixed",
            marginTop: "35px",
            right: "5px",
            width: "174px",
            height: "auto",
            background: "#FFFFFF 0% 0% no-repeat padding-box",
            border: "1px solid #006F35",
            borderRadius: "10px",
            opacity: 1,
            font: "normal normal 600 12px/14px Open Sans",
            letterSpacing: "0px",
            color: "#707070",
            padding: "0px 6px ",
            minHeight: "80px",
            maxHeight: "340px",
            paddingBottom: "10px",
          }}
        >
          <div style={{ padding: "5px", color: "black" }}>
            {tool === MapTools.DISTANCE
              ? "Measure distance"
              : "Measure area"}
          </div>
          <div style={{ padding: "5px" }}>
            Click on the map to add to your path
          </div>
          {tool === MapTools.AREA ? (
            <div style={{ padding: "5px", color: "black" }}>
              Total : {displayArea(totalDistance)}<sup>2</sup>
            </div>
          ) : (
            <div style={{ padding: "5px", color: "black" }}>
              Total : {displayDistance(totalDistance)}
            </div>
          )}
        </div>
      )}
    </>
  )
};

export default MeasureToolTotalStats;